import React from 'react'
import AllPages from './pages/AllPages'

export default function App() {
  return (<AllPages/> )
}
